import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import BootstrapVue from "bootstrap-vue/dist/bootstrap-vue.esm";
import IconsPlugin from "bootstrap-vue";
import "bootstrap-vue/dist/bootstrap-vue.min.css";
import axios from "axios";
import VueAxios from "vue-axios";
import store from "./store";
import AuthPlugin from "./plugins/auth";

Vue.config.productionTip = false;
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(VueAxios, axios);
Vue.use(AuthPlugin);

Vue.prototype.$apikey = {
  "x-api-key": "WEqEfodYfW3cSpQ99TGlD3pJFCbB0KAG6byvLEpm",
};

Vue.prototype.$apikeyPost = {
  headers: {
    "Content-Type": "application/json",
    "x-api-key": "WEqEfodYfW3cSpQ99TGlD3pJFCbB0KAG6byvLEpm",
  },
};

Vue.prototype.$environment = "PROD";

export const VariableExport = () => {
  return {
    apikeyPost: Vue.prototype.$apikeyPost,
    environment: Vue.prototype.$environment,
  };
};

require("./assets/CSS/SeraphProtectCSS.css");
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
